import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { TicketOptionContext } from "../Context/TicketOptionContext";

class TicketOptionInitStep extends StepFlow {
    get stepName() { return "TicketOptionInit_Step"; }

    async onExecute(): Promise<void> {
        console.log("Ticket Option Init step call............")
        const context = this.getCtx<TicketOptionContext>("ticketOptionContext")!
        context.routeTo = ["TicketOption_Step"]
        this.next()
    }

}
export const ticketOptionInitStepDefinition = new StepDefinition({
    stepName: "TicketOptionInit_Step",
    stepClass: TicketOptionInitStep
});